import { cn } from "@tine/designsystem-utils";
import type { CSSProperties } from "react";

import type { DayFlagLabel } from "../../../common/types/calendarTypes";

type CalendarKeysContext = "default" | "delivery-date-picker";

type Size = "compact" | "regular";

const style: CSSProperties & Record<string, string> = {
   "--button-border-radius": "0.25rem"
};
export type CalendarKeysProps = {
   flagLabels: DayFlagLabel[];
   context?: CalendarKeysContext;
   size?: Size;
};

const CalendarKey = ({ flag, label, size }: DayFlagLabel & { size: Size }) => {
   const keyClassName = cn("rounded-button border-2 border-solid leading-none", {
      "h-7 w-7 px-button-compact-padding-x py-button-compact-padding-y": size === "compact",
      "h-8 w-8 px-button-regular-padding-x py-button-regular-padding-y": size === "regular",
      "border-calendar-selected-bg bg-calendar-selected-bg text-calendar-selected-text": flag === "selected",
      "border-button-secondary-border bg-button-secondary-bg text-button-secondary-text": flag === "secondary",
      "border-calendar-cancelled-border bg-calendar-cancelled-bg text-calendar-cancelled-text": flag === "cancelled",
      "bg-calendar-selectable-bg border-0": flag === "selectable"
   });
   return (
      <div
         role="presentation"
         className={cn("flex flex-grow-0 items-center gap-1", { "text-sm": size === "compact" })}
         style={style}
      >
         <div className={keyClassName} />
         {label}
      </div>
   );
};

const CalendarKeys = ({ flagLabels, size = "compact" }: CalendarKeysProps) => {
   return (
      <>
         {flagLabels.map(({ flag, label }) => (
            <CalendarKey key={flag} flag={flag} label={label} size={size} />
         ))}
      </>
   );
};

export default CalendarKeys;
